<template>
    <div class="addMerchant-box">
        <el-form :model="form" ref="form" label-width="120px" class="addMerchant-form">
            <titleName titleName="基本信息"></titleName>
            <el-form-item label="商家名称：" prop="businessName"
                :rules="{ required: true, message: '请输入商家名称', trigger: 'blur' }">
                <el-input v-model="form.businessName" placeholder="请输入商家名称" style="width:300px"></el-input>
            </el-form-item>
            <div class="form-flex">
                <el-form-item label="联系人：" prop="businessContact"
                    :rules="{ required: true, message: '请输入联系人', trigger: 'blur' }">
                    <el-input v-model="form.businessContact" placeholder="请输入联系人" style="width:300px"></el-input>
                </el-form-item>
                <el-form-item label="联系电话：" prop="businessPhone"
                    :rules="{ required: true, message: '请输入联系电话', trigger: 'blur' }">
                    <el-input v-model="form.businessPhone" placeholder="请输入联系电话" style="width:300px"></el-input>
                </el-form-item>
            </div>
            <div class="form-flex2">
                <el-form-item label="联系地址：" prop="businessAddress"
                    :rules="{ required: true, message: '请输入联系地址', trigger: 'blur' }">
                    <el-input v-model="form.businessAddress" placeholder="请输入联系地址" style="width:300px"></el-input>
                </el-form-item>
                <el-form-item label="营业执照：" label-width="200px" prop="businessLicense"
                    :rules="{ required: true, message: '请上传营业执照', trigger: 'blur' }">
                    <el-upload class="avatar-uploader" :action="projectName + '/common/backstage/file/fileupload'"
                        :headers="headers" :show-file-list="false" :on-success="handleAvatarSuccess"
                        :before-upload="beforeAvatarUpload">
                        <img v-if="businessLicense" :src="businessLicense" class="avatar" />
                        <div v-else class="avatar-uploader-icon">
                            <i class="el-icon-plus"></i>
                            <p class="icon-name">上传图片，限2M</p>
                        </div>
                    </el-upload>
                </el-form-item>
            </div>
            <div>
                <el-form-item label="身份证照片：" label-width="120px" prop="idCardFront"
                    :rules="{ required: true, message: '请上传身份证正反面', trigger: 'blur' }">
                    <div class="form-flex2">
                        <el-upload class="avatar-uploader" :action="projectName + '/common/backstage/file/fileupload'"
                            :headers="headers" :show-file-list="false" :on-success="handleAvatarSuccess2"
                            :before-upload="beforeAvatarUpload">
                            <img v-if="idCardFront" :src="idCardFront" class="avatar" />
                            <div v-else class="avatar-uploader-icon">
                                <i class="el-icon-plus"></i>
                                <p class="icon-name">身份证正面，限2M</p>
                            </div>
                        </el-upload>
                        <el-upload style="margin-left: 10px;" class="avatar-uploader"
                            :action="projectName + '/common/backstage/file/fileupload'" :headers="headers"
                            :show-file-list="false" :on-success="handleAvatarSuccess3"
                            :before-upload="beforeAvatarUpload">
                            <img v-if="idCardBack" :src="idCardBack" class="avatar" />
                            <div v-else class="avatar-uploader-icon">
                                <i class="el-icon-plus"></i>
                                <p class="icon-name">身份证反面，限2M</p>
                            </div>
                        </el-upload>
                    </div>
                </el-form-item>
            </div>
            <titleName titleName="店铺信息"></titleName>
            <div class="form-flex">
                <el-form-item label="店铺性质：" prop="publishIs"
                    :rules="{ required: true, message: '请选择', trigger: 'blur' }">
                    <el-select v-model="form.publishIs" style="width:300px">
                        <el-option label="预发布" :value="1"></el-option>
                        <el-option label="非预发布" :value="0"></el-option>
                    </el-select>

                </el-form-item>
                <el-form-item label="店铺名称：" prop="shopName"
                    :rules="{ required: true, message: '请输入店铺名称', trigger: 'blur' }">
                    <el-input v-model="form.shopName" placeholder="请输入店铺名称" style="width:300px"></el-input>
                </el-form-item>
            </div>
            <div class="form-flex" v-if="form.publishIs==0">
                <el-form-item label="预定天数：" prop="bookingDays"
                    :rules="{ pattern: /^[1-9]\d*$/,required: true, message: '请输入正整数', trigger: 'blur' }">
                    <el-input v-model="form.bookingDays" placeholder="请输入" style="width:300px">
                        <span slot="suffix">天</span>
                    </el-input>
                </el-form-item>
            </div>
            <div class="form-flex">
                <el-form-item label="店铺账号：" prop="shopAccount"
                    :rules="{ required: true, message: '请输入店铺账号', trigger: 'blur' }">
                    <el-input v-model="form.shopAccount" placeholder="请输入店铺账号" style="width:300px"></el-input>
                </el-form-item>
                <el-form-item label="联系人：" prop="shopContact"
                    :rules="{ required: true, message: '请输入联系人', trigger: 'blur' }">
                    <el-input v-model="form.shopContact" placeholder="请输入联系人" style="width:300px"></el-input>
                </el-form-item>
            </div>
            <div class="form-flex">

                <el-form-item label="联系电话：" prop="shopPhone"
                    :rules="{ required: true, message: '请输入联系电话', trigger: 'blur' }">
                    <el-input v-model="form.shopPhone" placeholder="请输入联系电话" style="width:300px"></el-input>
                </el-form-item>
                <el-form-item label="联系地址：" class="mb50" prop="shopAddress"
                    :rules="{ required: true, message: '请输入联系地址', trigger: 'blur' }">
                    <el-input v-model="form.shopAddress" placeholder="请输入联系地址" style="width:300px"></el-input>
                </el-form-item>
            </div>
            <div class="form-flex2">
                <!--  prop="companyDoor" -->
                <el-form-item label="公司门头照片："
                    :rules="{ required: true, message: '请上传公司门头照片', trigger: 'blur' }">
                    <el-upload style="margin-right: 230px;" class="avatar-uploader"
                        :action="projectName + '/common/backstage/file/fileupload'" :headers="headers"
                        :show-file-list="false" :on-success="handleAvatarSuccess4" :before-upload="beforeAvatarUpload">
                        <img v-if="companyDoor" :src="companyDoor" class="avatar" />
                        <div v-else class="avatar-uploader-icon">
                            <i class="el-icon-plus"></i>
                            <p class="icon-name">上传图片，限2M</p>
                        </div>
                    </el-upload>
                </el-form-item>
                <!--  prop="companyEnvironment" -->
                <el-form-item label="公司环境照片："
                    :rules="{ required: true, message: '请上传公司环境照片', trigger: 'blur' }">
                    <el-upload class="avatar-uploader" :action="projectName + '/common/backstage/file/fileupload'"
                        :headers="headers" :show-file-list="false" :on-success="handleAvatarSuccess5"
                        :before-upload="beforeAvatarUpload">
                        <img v-if="companyEnvironment" :src="companyEnvironment" class="avatar" />
                        <div v-else class="avatar-uploader-icon">
                            <i class="el-icon-plus"></i>
                            <p class="icon-name">上传图片，限2M</p>
                        </div>
                    </el-upload>
                </el-form-item>
            </div>
            <titleName titleName="银行账户信息"></titleName>
            <div class="form-flex">
                <el-form-item label="收款账户：" prop="collectionAccount"
                    :rules="{ required: true, message: '请输入收款账户', trigger: 'blur' }">
                    <el-input v-model="form.collectionAccount" placeholder="请输入收款账户" style="width:300px"></el-input>
                </el-form-item>
                <el-form-item label="提现手续费：" prop="premium"
                    :rules="{ required: true, message: '请输入提现手续费', trigger: 'blur' }">
                    <el-input v-model="form.premium" placeholder="请输入提现手续费" style="width:300px"></el-input>
                </el-form-item>
            </div>
            <div class="form-flex">
                <el-form-item label="开户行：" prop="bank" :rules="{ required: true, message: '请输入开户行', trigger: 'blur' }">
                    <el-input v-model="form.bank" placeholder="请输入开户行" style="width:300px"></el-input>
                </el-form-item>
                <el-form-item label="账号：" prop="bankAccount"
                    :rules="{ required: true, message: '请输入账号', trigger: 'blur' }">
                    <el-input v-model="form.bankAccount" placeholder="请输入账号" style="width:300px"></el-input>
                </el-form-item>
            </div>

            <div class="bottom-btn">
                <el-button @click="$router.go(-1)">取 消</el-button>
                <el-button type="primary" @click="makeSure">确 定</el-button>
            </div>
        </el-form>

    </div>
</template>

<script>
import { projectName } from "@/util/config";
import titleName from '@/components/titleName';
import { fileDownLoad } from "@/api/systemManagement";
import { saveOrUpdateBusiness, businessDetail, } from "@/api/merchantManagement.js"
export default {
    components: { titleName },
    data() {
        return {
            projectName,
            headers: {
                sessionId: sessionStorage.getItem("access_token"),
                tenantId: '-1'
            },
            form: {},
            businessId: "",
            businessLicense: '',
            idCardFront: '',
            idCardBack: '',
            companyDoor: '',
            companyEnvironment: '',
            shopState: '',
        }
    },
    mounted() {
        this.businessId = this.$route.query.businessId
        if (this.businessId) {
            this.getAllDetais(this.businessId)
        }
    },
    methods: {
        // 图片回显
        async picPreview(filePath) {
            let data = {
                filePath: filePath,
                downloadOrRead: 'download'
            }
            let res = await fileDownLoad(data)
            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.readAsDataURL(res.data);
                reader.onload = (e) => {
                    const imgs = e.target.result;
                    resolve(imgs);
                };
                reader.onerror = (error) => {
                    reject(error);
                };
            });
        },
        //图片上传
        handleAvatarSuccess(res, file) {
            let pic = res.data.nginxFileReadPath;
            this.$set(this.form, 'businessLicense', pic);
            this.picPreview(pic).then(imageData =>{
                this.businessLicense  = imageData
            })
            this.form = { ...this.form }
        },
        //身份证正面上传
        handleAvatarSuccess2(res, file) {
            let pic = res.data.nginxFileReadPath;
            this.$set(this.form, 'idCardFront', pic)
            // 图片回显
            this.picPreview(pic).then(imageData =>{
                this.idCardFront  = imageData
            })
            this.form = { ...this.form }
        },
        //身份证反面上传
        handleAvatarSuccess3(res, file) {
            let pic = res.data.nginxFileReadPath;
            this.$set(this.form, 'idCardBack', pic)
            this.picPreview(pic).then(imageData =>{
                this.idCardBack  = imageData
            })
            this.form = { ...this.form }
        },
        //公司门头照片
        handleAvatarSuccess4(res, file) {
            let pic = res.data.nginxFileReadPath;
            this.$set(this.form, 'companyDoor', pic)
            this.picPreview(pic).then(imageData =>{
                this.companyDoor = imageData
            })
            this.form = { ...this.form }
        },
        //公司环境照片
        handleAvatarSuccess5(res, file) {
            let pic = res.data.nginxFileReadPath;
            this.$set(this.form, 'companyEnvironment', pic)
            this.picPreview(pic).then(imageData =>{
                this.companyEnvironment = imageData
            })
            this.form = { ...this.form }
        },
        // 图片上传
        beforeAvatarUpload(res, file) {
        },
        makeSure() {
            this.$refs.form.validate((valid) => {
                if (valid) {
                    let data = {
                        ...this.form,
                        businessShopList: [
                            {
                                publishIs: this.form.publishIs,
                                shopName: this.form.shopName,
                                shopAccount: this.form.shopAccount,
                                shopContact: this.form.shopContact,
                                shopPhone: this.form.shopPhone,
                                shopAddress: this.form.shopAddress,
                                shopId: this.form.shopId,
                                shopState: this.shopState,
                                companyDoor: this.form.companyDoor,//公司门头照片
                                companyEnvironment: this.form.companyEnvironment,//公司环境照片
                                bookingDays: Number(this.form.bookingDays)
                            }
                        ]
                    }
                    saveOrUpdateBusiness(data).then(res => {
                        if (res.code == 1) {
                            this.$message.success("操作成功！");
                            this.$router.go(-1)
                        }
                    })
                }
            })
        },
        getAllDetais(id) {
            businessDetail({ businessId: id }).then(res => {
                if (res.code == 1) {
                    // this.form = res.data;
                    let data = res.data;
                    this.form = data || {}
                    this.shopState = data.businessShopList[0].shopState
                    this.form.publishIs = data.businessShopList[0].publishIs
                    this.form.shopName = data.businessShopList[0].shopName
                    this.form.shopAccount = data.businessShopList[0].shopAccount
                    this.form.shopContact = data.businessShopList[0].shopContact
                    this.form.shopPhone = data.businessShopList[0].shopPhone
                    this.form.shopAddress = data.businessShopList[0].shopAddress
                    this.form.shopId = data.businessShopList[0].shopId
                    this.form.companyDoor = data.businessShopList[0].companyDoor
                    this.form.companyEnvironment = data.businessShopList[0].companyEnvironment
                    this.form.bookingDays = data.businessShopList[0].bookingDays
                    this.picPreview(data.businessLicense).then(imageData =>{
                        this.businessLicense = imageData
                    })
                    this.picPreview(data.idCardFront).then(imageData =>{
                        this.idCardFront = imageData
                    })
                    this.picPreview(data.idCardBack).then(imageData =>{
                        this.idCardBack = imageData
                    })
                    this.picPreview(data.businessShopList[0].companyDoor).then(imageData =>{
                        this.companyDoor = imageData
                    })
                    this.picPreview(data.businessShopList[0].companyEnvironment).then(imageData =>{
                        this.companyEnvironment = imageData
                    })
                    this.form = { ...this.form }
                }
            })
        }
    }
}
</script>

<style lang="less" scoped>
.addMerchant-box {
    width: 100%;

    .form-flex {
        display: flex;
        justify-content: space-between;
    }

    .form-flex2 {
        display: flex;
    }

    .addMerchant-form {
        width: 55%;
        margin: 0 auto;
    }

    .bottom-btn {
        margin: 30px 0;
        text-align: center;
    }
}

.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 140px;
    height: 88px;
    text-align: center;
    border: 1px dashed;

    .icon-name {
        font-size: 12px;
    }
}

.avatar {
    width: 140px;
    height: 88px;
    display: block;
}
</style>